import { Box, Typography } from "@mui/material"
import { StateSummaryRow } from "./StateSummaryRow"
import { RangeConfig, ThresholdConfig } from "@features/alertsConfigurationV2/schemas/alertConfigurationSchema"
import { MetricUnit } from "@/__generated__/graphql";

interface ConfigurationsPanelProps {
  configurations: (RangeConfig | ThresholdConfig)[];
  unit: MetricUnit;
}

export const ConfigurationsPanel = ({ configurations, unit }: ConfigurationsPanelProps) => {
  return (
    <>
    <Box
      sx={{
        border: '1px solid white',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        width: 1,
        p: 1
      }}
    >
      <Typography>Rangos configurados</Typography>
    </Box>
    <Box 
      sx={{
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 3,
        height: 1,
        px: 1,
        pt: 4, 
        backgroundColor: '#1B2229'
      }}
    >
        <Box
          sx={{
            width: 0.9,
            display: 'flex',
            p: 1,
            gap: 2
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: 0.25
            }}
          >
            <Typography variant="h6">Alerta</Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: 0.75
            }}
          >
            <Typography variant="h6">Rango</Typography>
          </Box>
        </Box>
        {configurations?.map((config: RangeConfig | ThresholdConfig, index: number) => (
          <StateSummaryRow 
            key={index}
            configuration={config}
            unit={unit}
            index={index}
          />
        ))}
    </Box>
    </>
  )
}